import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/legal/legalConfig";

/**
 * Sprint 8a — UnknownDomainPage
 *
 * Wird gerendert, wenn `/api/public/domain/resolve` für den aktuellen Hostname
 * `type: "unknown"` zurückgibt. Bewusst minimalistisch, kein Branding-Leak.
 */
export default function UnknownDomainPage() {
  const host = (typeof window !== "undefined" ? window.location.hostname : "") || "";
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6" data-testid="unknown-domain-page">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center">
        <div className="w-12 h-12 rounded-full bg-slate-100 mx-auto mb-4 flex items-center justify-center">
          <span className="text-2xl text-slate-400">?</span>
        </div>
        <h1 className="text-xl font-extrabold text-slate-900" style={{ fontFamily: "Manrope, sans-serif" }}>
          Diese Domain ist nicht registriert
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          Die Adresse <code className="text-xs bg-slate-100 px-1.5 py-0.5 rounded">{host}</code> ist
          aktuell nicht als Agenturportal- oder Mandanten-Angebotsdomain bei {BRAND.name} hinterlegt.
        </p>
        <p className="mt-4 text-xs text-slate-500">
          Wenn du Betreiber dieser Domain bist, prüfe bitte den DNS-Eintrag und den Domainstatus in der Plattform.
        </p>
        <div className="mt-6">
          <a
            href={BRAND.homepage}
            className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-orange-600 hover:bg-orange-700 rounded-md"
            data-testid="unknown-domain-cta"
          >
            Zur {BRAND.name}-Startseite
          </a>
        </div>
      </div>
    </div>
  );
}
